<template>
<div id="hotel" :class="{'pa-2 ma-2':$vuetify.breakpoint.smAndUp}" v-scroll="onScroll" style="padding-bottom: 70px !important">

    <v-container fluid :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-0': $vuetify.breakpoint.xs, 'pt-3': $vuetify.breakpoint.smAndUp}">
        <!-- loadig data -->
        <v-card v-if="loading_data">
            <v-card-title primary-title>
                Data is loading
            </v-card-title>
            <v-progress-linear :indeterminate="true" height="3"></v-progress-linear>
        </v-card>
        <v-card v-else flat>
            <div :class="[$vuetify.breakpoint.mdAndUp?'row':'']">

                <div :class="{'menu-hotel': menu_hotel, 'left-menu px-3':true}">
                    <v-list :class="{'pa-0': $vuetify.breakpoint.smAndDown }">
                        <div :class="[$vuetify.breakpoint.mdAndUp?'':'d-flex','list-menu']">
                            <v-list-item v-for="(component, index) in hotel_components" :key="index" :class="{'ma-2':true,'border': active_component.name == component.name , 'validate': validate, 'non':  !component.validate}" @click="active_component.name = component.name,  active_component.validate = component.validate">
                                <v-list-item-content>
                                    <v-list-item-title class="text-capitalize">{{ $t('hotel.menu.'+[component.title]) }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </div>
                    </v-list>
                </div>

                <v-col>
                    <transition name="component-fade" mode="out-in">
                        <component :is_mounted="is_mounted" @mounted="is_mounted = true" :is="active_component.name" :active='active_component' :item="item" :config="config" :new_images="new_images" @validate="updateValidate($event)" @updatePhotos="updatePhotos($event)"
                            @updateDefaultPhoto="updateDefaultPhoto($event)" @policy_children="updatePolicyChildren($event)" />
                    </transition>
                </v-col>
            </div>
        </v-card>



    </v-container>
    <v-snackbar v-model="error_data" color="error" bottom left>
        <div>
            <template v-for="error_field in fields_error">
                <div>
                    {{error_field}}
                </div>
            </template>
        </div>
    </v-snackbar>

    <!-- footer -->
    <im-footer :create='false' :update="(modified&&(new_images.length==0)&&(default_image_id==null))" :loading="loading_save" @save="checkHotelData()" @refresh="refresh()" />
    <!-- ./ footer -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import logger from "../../logger.js";
import defaults from "../../components/utils/PropDefaults.js";
import IMFooter from '../../components/utils/IMFooter.vue';
import Validate from "../../components/items/Hotel/service/validate.js";
import HotelService from "../../components/items/Hotel/service/hotel.service.js";
import IMHotelDetail from "../../components/items/Hotel/items/Detail.vue";
import IMHotelContact from "../../components/items/Hotel/items/Contact.vue";
import IMHotelLocation from "../../components/items/Hotel/items/Geolocation.vue";
import IMHotelPolicy from "../../components/items/Hotel/items/Policy.vue";
import IMHotelFacilities from "../../components/items/Hotel/items/Facilities.vue";
import IMHotelMedia from "../../components/items/Hotel/items/Media.vue";
import IMHotelBilling from "../../components/items/Hotel/items/Billing.vue";

export default {
    props: ["hotel"],
    name: `item-hotel`,
    components: {
        "im-hotel-details": IMHotelDetail,
        "im-hotel-contact": IMHotelContact,
        "im-hotel-billing": IMHotelBilling,
        "im-hotel-location": IMHotelLocation,
        "im-hotel-policy": IMHotelPolicy,
        "im-hotel-facilities": IMHotelFacilities,
        "im-hotel-media": IMHotelMedia,
        "im-footer": IMFooter,
    },
    data() {
        return {
            tab: null,
            is_mounted: false,
            menu_hotel: false,
            offset_top: null,
            validate: false,
            fields_error: [],
            error_data: false,
            active_component: {
                name: 'im-hotel-details',
                validate: true
            },
            hotel_components: [
                {
                    name: 'im-hotel-details',
                    title: 'details',
                    validate: true,
                }, {
                    name: 'im-hotel-contact',
                    title: 'contact',
                    validate: true,
                }, {
                    name: 'im-hotel-location',
                    title: 'geolocation',
                    validate: true,
                }, {
                    name: 'im-hotel-billing',
                    title: 'billing',
                    validate: true,
                }, {
                    name: 'im-hotel-policy',
                    title: 'policy',
                    validate: true,
                }, {
                    name: 'im-hotel-facilities',
                    title: 'facilities',
                    validate: true,
                }, {
                    name: 'im-hotel-media',
                    title: 'media',
                    validate: true,
                },
            ],
            hotel_component_name: 'im-hotel-details',
            config: {},
            loading_save: false,
            loading_data: false,
            tab_hotel: null,
            center_position: {
                lat: 44.439663,
                lng: 26.096306
            },
            new_images: [],
            default_image_id: null,
            selected_facilities_ids: [],
            selected_activities_ids: [],
            item: this.$clone(defaults.hotel_item),
            original: this.$clone(defaults.hotel_item),
            original_slug: null,
            policy_children: this.$clone(defaults.hotel_item.static.policy.children),
            response: {
                hotel: {},
                policy_refundable: {},
                policy_nonrefundable: {},
                rate_plan: {},
                room_single: {},
                room_double: {},
            },

        };
    },

    watch: {
        'hotel.id': function (old_hotel, new_hotel) {
            if(this.$route.params.id != this.hotel.id) {
                this.$router.push({
                    path: '/' + this.hotel.slug + '/inventory-pricing'
                });
            }

        },
    },
    computed: {
        modified: function () {
            return (JSON.stringify({ ...this.item
            }) == JSON.stringify({ ...this.original
            })) && (JSON.stringify({ ...this.policy_children
            }) == JSON.stringify({ ...this.original.static.policy.children
            }));
        },
    },

    mounted() {
        this.getAllItems();
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        onScroll(e) {
            this.offset_top = window.pageYOffset || document.documentElement.scrollTop;
            if(this.offset_top > 50) {
                this.menu_hotel = true;
            } else {
                this.menu_hotel = false;
            }
        },

        getAllItems() {
            this.loading_data = true;
            this.getItemConfigs()
                .then(() => this.getItem())
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading_data = false;
                });
        },

        getItemConfigs() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/config';

            return this.$axios.get(endpoint)
                .then(response => {
                    this.config = response.data;
                    let accepted_cards = []
                    Object.keys(response.data.accepted_cards)
                        .forEach(function (item) {
                            accepted_cards.push({
                                slug: item,
                                text: response.data.accepted_cards[item]
                            })
                        })
                    this.config.accepted_cards_slug = accepted_cards;
                    this.config.unit_type_slug = Object.keys(response.data.unit_types);
                    this.config.currencies_slug = Object.keys(response.data.currencies);
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
        },

        async getItem() {
            if(this.$route.params.id) {
                let hotel = await HotelService.getHotel(this.$route.params.id);
                if(hotel) {
                    this.item = hotel;
                    this.original_slug = hotel.slug;
                    this.item.static.defaults.stars = Number(this.item.static.defaults.stars);
                    this.center_position = {
                        lat: Number(this.item.static.geo.lat),
                        lng: Number(this.item.static.geo.lon)
                    }
                    // set new addres format to have nr and building details
                    if(!this.item.address) {
                        this.item.address = this.$clone(defaults.hotel_item.address)
                    }
                    if(!this.item.description) {
                        this.item.description = {
                            ro: '',
                            en: ''
                        }
                    }
                    this.original = this.$clone(this.item);
                    this.policy_children = this.$clone(this.item.static.policy.children);
                    this.original.static.defaults.stars = Number(this.original.static.defaults.stars);
                }
            }
        },

        updatePhotos(new_photos) {
            this.new_images = new_photos;
        },

        validateHotel() {
            let valid_hotel = true;

            let index = this.hotel_components.findIndex(item => item.name === this.active_component.name);
            this.active_component.validate = this.hotel_components[index].validate;
            if(!this.hotel_components[6].validate) {
                valid_hotel = false;
            }
            // check if some data validation for when form wasn't completed at all
            if(!this.$route.params.id) {
                // test if images are added (only one image is required)
                if(this.new_images.length) {
                    this.hotel_components[6].validate = true;
                    if(this.active_component.name == this.hotel_components[6].name) {
                        this.active_component.validate = true;
                    }
                } else {
                    valid_hotel = false;
                    logger.error('no image added', 'Hotel -> Media')
                        .then(() => null);
                    this.hotel_components[6].validate = false;
                    if(this.active_component.name == this.hotel_components[6].name) {
                        this.active_component.validate = false;
                    }
                }
                // test if geolocation form was "touch"
                if(!this.item.static.geo.address && this.hotel_components[2].validate) {
                    valid_hotel = false;
                    this.hotel_components[2].validate = false;
                }
                if(this.center_position.lat == this.item.static.geo.lat && this.center_position.lng == this.item.static.geo.lon) {
                    valid_hotel = false;
                    this.hotel_components[2].validate = false;
                }
                // test if contact form was "touch"
                if(!this.item.email && this.hotel_components[1].validate) {

                    valid_hotel = false;
                    this.hotel_components[1].validate = false;
                }
                // test if contact form was "touch"
                if(!this.hotel_components[4].validate) {
                    valid_hotel = false;
                }
                // test if contact form was "touch"
                if(!this.item.static.defaults.currency && this.hotel_components[3].validate) {
                    valid_hotel = false;
                    this.hotel_components[3].validate = false;
                }
            } else {
                if(this.hotel_components[6].validate == false) {
                    valid_hotel = false;
                }
            }
            if(this.active_component.name == this.hotel_components[0].name) {
                if(this.hotel_components[0].validate) {
                    this.active_component.validate = true;
                } else {
                    valid_hotel = false;
                    this.active_component.validate = false;
                }
            }
            return valid_hotel
        },

        async checkSlug() {
            let slug = null;
            let i = 0;
            let hotel_model = this.item;
            while(!slug) {
                slug = await HotelService.checkSlug(i, this.item.slug)
                i++;
            }
            return slug;
        },

        async checkHotelData() {
            this.loading_save = true;
            this.validate = true;
            this.fields_error = [];
            // this.validateHotel();
            this.fields_error = await Validate.validate(this.item);
            if(this.fields_error.length) {
                this.error_data = true;
                logger.error(JSON.stringify(this.fields_error), 'Hotel.vue')
                    .then(() => null);
                this.loading_save = false;
                return
            }
            if(this.original_slug !== this.item.slug && this.$route.params.id !== undefined) {
                this.item.slug = await this.checkSlug();
                this.saveItem();
            } else {
                this.saveItem();
            }
        },

        async saveItem() {
            this.loading_save = true;

            // prepare some data for saving
            let hotel = this.$clone(this.item);
            hotel.static.images = this.$clone(this.new_images);
            if(this.item.address.number) {
                hotel.static.geo.address = this.item.static.geo.address + " nr." + this.item.address.number
            }
            if(this.item.address.building) {
                hotel.static.geo.address = this.item.static.geo.address + " " + this.item.address.building
            }

            hotel.static.images.map(item => delete item.id);
            delete hotel.address;
            delete hotel.financial;
            delete hotel.created_at;
            delete hotel.deleted_at;
            delete hotel.old_id;
            hotel.static.policy.children = this.$clone(this.policy_children);

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";


            if(this.default_image_id) {
                this.$axios.post(endpoint + hotel.id + "/main-image/" + this.default_image_id)
                    .then(response => {
                        this.success(this.$t('hotel.message_default_image'));
                        this.validate = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.error("Oops, something went wrong!");
                    })
                    .finally(() => {
                        // this.loading_save = false;
                        this.default_image_id == null;
                    });
            }

            if(this.$route.params.id !== undefined) {
                let response_hotel = await HotelService.updateHotel(hotel.id, hotel);
                if(response_hotel) {
                    this.getItem();
                    this.new_images = [];
                    this.validate = false;
                }
                this.loading_save = false;

            } else {
                this.createHotel(hotel);
            }
        },

        updateProcent(index, value) {
            this.hotel_components[index].procent += value;
        },

        updateDefaultPhoto(id) {
            let value = id.toString();
            if(value.includes("abc")) {
                // photo is a new one added
                let value_index = this.new_images.findIndex(photo => photo.id === value);
                this.new_images[value_index].default = true;
                this.default_image_id = null;
            } else {
                // photo is an old one and we need to call api
                this.default_image_id = id;
            }
        },

        updateValidate(value) {
            this.hotel_components[value[0]].validate = value[1];
        },

        updatePolicyChildren(value) {
            this.policy_children = this.$clone(value);
            if(value.allowed == false) {
                this.policy_children.allowed = "0";
            }
            if(value.allowed == true) {
                this.policy_children.allowed = "1";
            }
            if(value.infants.allowed == false) {
                this.policy_children.infants.allowed = "0";
            }
            if(value.infants.allowed == true) {
                this.policy_children.infants.allowed = "1";
            }
            if(value.small_children.allowed == false) {
                this.policy_children.small_children.allowed = "0";
            }
            if(value.small_children.allowed == true) {
                this.policy_children.small_children.allowed = "1";
            }
            if(value.big_children.allowed == false) {
                this.policy_children.big_children.allowed = "0";
            }
            if(value.big_children.allowed == true) {
                this.policy_children.big_children.allowed = "1";
            }
        },

        refresh() {
            this.new_images = [];
            this.default_image_id = null;
            this.getItem();
        },

        async createHotel(value) {
            let hotel_model = value;
            let slug = null;
            let i = 0;
            while(!slug) {
                slug = await HotelService.checkSlug(i, value.slug)
                i++;
            }
            hotel_model.slug = slug;

            this.response.hotel = await HotelService.createHotel(hotel_model);
            this.new_images = [];
            let policy_refundable_model = this.prepareCancellationPoliciesRefundable();
            let policy_nonrefundable_model = this.prepareCancellationPoliciesNonRefundable();
            this.response.policy_nonrefundable = await HotelService.createPolicy(policy_nonrefundable_model);
            let rate_plan_model = this.prepareRatePlan();
            this.response.policy_refundable = await HotelService.createPolicy(policy_refundable_model);
            this.response.rate_plan = await HotelService.createRatePlan(rate_plan_model);
            let room_single_model = this.prepareRoomSingle();
            let room_double_model = this.prepareRoomDouble();
            await HotelService.createRoom(room_single_model);
            await HotelService.createRoom(room_double_model);
            this.validate = false;
            this.loading_save = false;
            this.success(this.$t('hotel.message_added'));
            this.$router.push({
                path: '/' + this.response.hotel.slug + '/inventory-pricing'
            });
        },

        prepareCancellationPoliciesRefundable() {
            let policy = this.$clone(defaults.cancellation_policy_item);
            policy.hotel_id = this.response.hotel.id;
            policy.refundable = true;
            policy.name = "Complet rambursabila";
            return policy
        },

        prepareCancellationPoliciesNonRefundable() {
            let policy = this.$clone(defaults.cancellation_policy_item);
            policy.hotel_id = this.response.hotel.id;
            policy.name = "Nerambursabila";
            return policy
        },

        prepareRatePlan() {
            let rate_plan = this.$clone(defaults.rate_plan_item);
            rate_plan.hotel_id = this.response.hotel.id;
            rate_plan.cancellation_policy_id = this.response.policy_nonrefundable.id;
            rate_plan.name = "Standard";
            return rate_plan
        },

        prepareRoomSingle() {
            let room = this.$clone(defaults.room_type_item);
            room.rate_plans = [this.response.rate_plan.id];
            room.hotel_id = this.response.hotel.id;
            room.standard = "single";
            room.slug = "single";
            room.config.occupancy = 1;
            room.name = "Camera Single";
            room.description = "Camera are 1 pat de cel puțin 90 cm lățime pentru o persoană";
            return room
        },

        prepareRoomDouble() {
            let room = this.$clone(defaults.room_type_item);
            room.rate_plans = [this.response.rate_plan.id];
            room.hotel_id = this.response.hotel.id;
            room.standard = "double";
            room.slug = "double";
            room.config.occupancy = 2;
            room.name = "Camera Dubla";
            room.description = "Camera are 1 pat de cel puțin 160 cm lățime pentru două persoane";
            return room
        },
    },

};
</script>
<style lang="stylus">
.border
    border-left: 2px solid black
    @media only screen and (max-width: 960px)
        border-left: none
        border-bottom: 2px solid black

.menu-hotel
    position: sticky
    top: 48px
    z-index: 2
    .list-menu
        background-color: white
        width: fit-content


.left-menu
    overflow: visible
    width: 180px
    @media only screen and (max-width: 960px)
        width: auto
        overflow-x: scroll

.back
    position: absolute
    height: 100%
    background-color: red
    left: 0
    top: 0
    -webkit-transition: width 2s
    /* For Safari 3.1 to 6.0 */
    transition: width 2s

</style>
